import { Injectable, signal } from '@angular/core';
import { busOption } from '../../route-form/components/route-form-options-panels/components/route-form-more-options/constants';

@Injectable({
  providedIn: 'root'
})
export class RouteResultsService {
  public resultOptionSelected = signal(busOption);
}
